export default "__VITE_ASSET__Stc6KUFc__"